import { ComputedRef, onMounted, watch } from "vue";
import { useModalStore } from "@/store/modal";
import { getCookie } from "@/utils/cookies";
import { APPROVED_AGE_COOKIE } from "@/utils/variables";
import { useUserStore } from "@/store/user.ts";
import { getTld } from "@/utils/urlHelper.ts";
import { useVisitStore } from "@/store/visit.ts";

export function useAgeVerification(loading: ComputedRef) {
  const modalStore = useModalStore();

  const canShowAgeApproval = () => {
    if (getCookie(APPROVED_AGE_COOKIE)) {
      return false;
    }

    if (useUserStore().isLoggedIn) {
      return false;
    }

    const tld = getTld();

    if (["net", "de", "ch", "com", "tv"].indexOf(tld) === -1) {
      return false;
    }

    const visit = useVisitStore().getVisit;
    const directOrganicVisit = !visit?.campaign && !document.referrer;

    return !(["tv", "com"].indexOf(tld) > -1 && !directOrganicVisit);
  };

  const onAppClick = (e: Event) => {
    if (!canShowAgeApproval()) {
      return;
    }

    const target = e.target as HTMLElement;
    const popupClick = target.className === "btn-exit";

    if (!getCookie(APPROVED_AGE_COOKIE) && !popupClick) {
      e.preventDefault();
      modalStore.showModal({ id: "modal-age-approval" });
    }
  };

  const checkAgePopup = () => {
    if (!canShowAgeApproval()) {
      return false;
    }

    modalStore.showModal({ id: "modal-age-approval" });
  };

  onMounted(checkAgePopup);

  watch(loading, checkAgePopup);

  return {
    onAppClick,
    checkAgePopup,
  };
}
